import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Servidor from "../config/Servidor";
import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";

export default function ReporteDiario() {
  const user = JSON.parse(localStorage.getItem("user"));
  const location = useLocation();
  const navigate = useNavigate();

  const cobrador = location.state?.cobrador || null;

  const [fecha, setFecha] = useState("");
  const [data, setData] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [menuAbierto, setMenuAbierto] = useState(false);

  const [clientesOpen, setClientesOpen] = useState(false);
  const [listasOpen, setListasOpen] = useState(false);
  const [informacionOpen, setInformacionOpen] = useState(false);
  const [notasOpen, setNotasOpen] = useState(false);

  const cargarReporte = async () => {
    if (!fecha) return;

    setCargando(true);
    try {
      const res = await axios.get(
        `${Servidor.IP}/reportediario/${cobrador.info_usuario.id_usuario}/${fecha}`
      );
      setData(res.data);
    } catch (error) {
      console.log("Error cargando reporte diario", error);
    }
    setCargando(false);
  };

  useEffect(() => {
    const ruta = location.pathname;
  
    // CLIENTES
    if (
      ruta === "/listaclientes" ||
      ruta === "/listacuentas" ||
      ruta === "/listadesactivados" ||
      ruta === "/listaeliminarcliente" ||
      ruta === "/listaeliminarcuenta"
    ) {
      setClientesOpen(true);
    }
  
    // LISTAS PERSONALIZADAS
    if (ruta === "/listaspersonalizadas") {
      setListasOpen(true);
    }
  
    // INFORMACION COBRO
    if (
      ruta === "/reportediario" ||
      ruta === "/ultimolugarregistrado" ||
      ruta === "/posicionclientes" ||
      ruta === "/enviarmensaje"
    ) {
      setInformacionOpen(true);
    }
  
    // NOTAS
    if (
      ruta === "/notascobro" ||
      ruta === "/notascobrosocio"
    ) {
      setNotasOpen(true);
    }
  
  }, [location.pathname]);
  useEffect(() => {
    if (fecha) cargarReporte();
  }, [fecha]);

  const getFechaActual = () => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    const mes = String(hoy.getMonth() + 1).padStart(2, "0");
    const dia = String(hoy.getDate()).padStart(2, "0");
    return `${año}-${mes}-${dia}`;
  };

  useEffect(() => {
    const hoy = getFechaActual();
    setFecha(hoy);
    cargarReporte(hoy);
  }, []);

  const formatearFechaHora = (fechaISO) => {
    if (!fechaISO) return "Sin pagos";

    const fecha = new Date(fechaISO);

    const año = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const dia = String(fecha.getDate()).padStart(2, "0");

    const horas = String(fecha.getHours()).padStart(2, "0");
    const minutos = String(fecha.getMinutes()).padStart(2, "0");
    const segundos = String(fecha.getSeconds()).padStart(2, "0");

    return `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
  };

  // Estilos nuevos bonitos
  const inputStyle = {
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #cbd5e1",
    width: "33%",
    maxWidth: "200px",
    background: "#ffffff",
    fontSize: "15px",
  };

  const buttonStyle = {
    padding: "8px 12px",
    background: "#0740A0",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "0.2s",
  };

  const buttonSmall = {
    padding: "6px 10px",
    background: "#0740A0",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
    transition: "0.2s",
  };

  const checkboxStyle = {
    width: "22px",
    height: "22px",
    cursor: "pointer",
  };

  const box = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    padding: "14px",
    background: "white",
    borderRadius: "10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    fontSize: "16px",
    flexWrap: "wrap",
    gap: "10px",
  };

  return (
    <div style={{ padding: 10 }}>
     {/* NAV SUPERIOR RESPONSIVE */}
<div
  style={{
    width: "100%",
    maxWidth: "100%",
    background: "#0740A0",
    color: "white",
    padding: "12px 16px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxSizing: "border-box",
    overflow: "hidden",
    wordWrap: "break-word",
  }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
     
         Supervisando a  {cobrador.persona?.nombre || cobrador.info_usuario.usuario}
  </h2>
  <h2
    style={{
      margin: 0,
      fontSize: "clamp(16px, 4vw, 20px)", // Se ajusta según pantalla
      fontWeight: "bold",
      lineHeight: 1.2,
    }}
  >
    
      {/* BOTÓN MENU */}
      <button
        onClick={() => setMenuAbierto(true)}
        style={{
          fontSize: 25,
          padding: 8,
          border: "none",
           background: "#0740A0",
    color: "white",
          cursor: "pointer",
        }}
      >
        ☰
      </button>
          {user.persona_nombre || user.usuario} 
  </h2>
  <p
    style={{
      margin: "4px 0 0 0",
      fontSize: "clamp(12px, 3vw, 15px)", // También responsivo
      opacity: 0.95,
      lineHeight: 1.2,
    }}
  >
    
  </p>
</div>

     {/* MENU LATERAL */}
      {menuAbierto && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            background: "rgba(0,0,0,0.4)",
            backdropFilter: "blur(2px)",
            zIndex: 999,
          }}
          onClick={() => setMenuAbierto(false)}
        >
          <div
            style={{
              width: 250,
              height: "100%",
              background: "white",
              padding: 20,
              boxShadow: "3px 0 10px rgba(0,0,0,0.3)",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2 style={{ marginTop: 0 }}>Menú</h2>

      {/* CLIENTES */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setClientesOpen(!clientesOpen)}
>
  👥 Clientes {clientesOpen ? "🔼" : "🔽"}
</p>

{clientesOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaclientes", { state: { cobrador } })}>
      📋 Listado de clientes
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listacuentas", { state: { cobrador } })} >
      💳 Listado de cuentas
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listadesactivados", { state: { cobrador } })}>
      ⛔ Clientes desactivados
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaeliminarcliente", { state: { cobrador } })}>
      ✅ Aprobar eliminación de cliente
    </p>
    <p style={{ cursor: "pointer" }} onClick={() => navigate("/listaeliminarcuenta", { state: { cobrador } })}>
      🗑️ Aprobar eliminación de cuenta
    </p>
  </div>
)}

{/* LISTAS PERSONALIZADAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setListasOpen(!listasOpen)}
>
  🗂️ Listas personalizadas {listasOpen ? "🔼" : "🔽"}
</p>

{listasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaspersonalizadas", { state: { cobrador } })}>
      📑 Ver listas personalizadas
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/filtroclientes", { state: { cobrador } })}>
  🔍 Filtros de clientes
</p>

{/* INFORMACIÓN COBRO */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setInformacionOpen(!informacionOpen)}
>
  💰 Información de cobro {informacionOpen ? "🔼" : "🔽"}
</p>

{informacionOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p  style={{
    cursor: "pointer",
    backgroundColor: "#1e40af", // azul
    color: "#ffffff",
    padding: "8px 12px",
    borderRadius: "10px",
    width: "fit-content",
    margin: "6px 0"
  }}>
      📊 Reporte diario
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/ultimolugarregistrado", { state: { cobrador } })}>
      📍 Último lugar registrado
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/posicionclientes", { state: { cobrador } })}>
      🧭 Posición de clientes
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/enviarmensaje", { state: { cobrador } })}>
      ✉️ Enviar mensaje
    </p>
  </div>
)}

{/* NOTAS */}
<p
  style={{ cursor: "pointer", fontWeight: "bold" }}
  onClick={() => setNotasOpen(!notasOpen)}
>
  📝 Notas {notasOpen ? "🔼" : "🔽"}
</p>

{notasOpen && (
  <div style={{ paddingLeft: 20 }}>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobro", { state: { cobrador } })}>
      🗒️ Notas de cobro
    </p>
    <p style={{ cursor: "pointer" }}   onClick={() => navigate("/notascobrosocio", { state: { cobrador } })}>
      🤝 Notas de cobro socio
    </p>
  </div>
)}

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/nuevaliquidacion", { state: { cobrador } })}>
  💵 Nueva liquidación
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/listaliquidadas", { state: { cobrador } })}>
  📃 Lista de liquidadas
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudmodificarcliente", { state: { cobrador } })}>
  ✏️ Solicitud modificar cliente
</p>

<p style={{ cursor: "pointer" }}   onClick={() => navigate("/solicitudgastos", { state: { cobrador } })}>
  🧾 Solicitud de gastos
</p>

       <p style={{ cursor: "pointer", fontWeight: "bold" ,color:"white"}}>
             final menu
              </p>
          </div>
        </div>
      )}

      {/* FECHA */}
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          style={inputStyle}
        />
      </div>

      {cargando && <p>Cargando reporte...</p>}
      {!cargando && fecha && !data && <p>No hay datos del día seleccionado.</p>}

      {/* REPORTE */}
      {data && (
        <div style={{ maxWidth: 900, margin: "0 auto" }}>

          {/* BASE DÍA */}
          <div style={box}>
            <span>Base Dia</span>
            <input placeholder="0.0" style={inputStyle}></input>
            <button style={buttonStyle}>Aplicar</button>
          </div>

          {/* BOTONES */}
          <div style={box}>
            <button style={buttonStyle}>Llamadas realizadas</button>
            <button style={buttonStyle}>Mensajes enviados</button>
          </div>

          {/* COBROS */}
          <div style={box}>
            <span>% Cobrar día actual</span>
            <strong>Bs. {data.caja?.estimado_cobrar || 0}</strong>
          </div>

          <div style={box}>
            <span>Total cobrado</span>
            <strong>
              Bs. {data.resumen.totalCobrado + data.resumen.totalAbonado}{" "}
              <small>
                (
                {data.caja?.estimado_cobrar
                  ? (
                      ((data.resumen.totalCobrado + data.resumen.totalAbonado) /
                        data.caja.estimado_cobrar) *
                      100
                    ).toFixed(2)
                  : 0}
                %)
              </small>
            </strong>
            <button style={buttonSmall}>Ver</button>
          </div>

          <div style={box}>
            <span>Total prestado</span>
            <strong>Bs. {data.resumen.totalVentas}</strong>
            <button style={buttonSmall}>Ver</button>
          </div>

          {/* CLIENTES */}
          <div style={box}>
            <span>Cantidad de clientes con pagos</span>
            <strong>
              Han pagado {data.visitas.length} cliente(s) de{" "}
              {data.clientesActivos} activo(s)
            </strong>
          </div>

          {/* HORAS */}
          <div style={box}>
            <span>Hora primer pago:</span>
            <strong>
              {formatearFechaHora(data.cobros[0]?.fecha || data.abonos[0]?.fecha)}
            </strong>
          </div>

          <div style={box}>
            <span>Hora último pago:</span>
            <strong>
              {formatearFechaHora(
                data.cobros[data.cobros.length - 1]?.fecha ||
                  data.abonos[data.abonos.length - 1]?.fecha
              )}
            </strong>
          </div>

          {/* HORARIOS DE MAPA */}
          <div style={box}>
            <span>Hora inicial del recorrido</span>
            <input placeholder="12:00 AM" style={inputStyle}></input>
          </div>

          <div style={box}>
            <span>Hora final del recorrido</span>
            <input placeholder="11:59 PM" style={inputStyle}></input>
          </div>

          <div style={box}>
            <span>Mostrar clientes en el mapa</span>
            <input type="checkbox" style={checkboxStyle}></input>
          </div>

          {/* CAJA DEL DÍA */}
          <div style={box}>
            <span>Caja del día (sin gastos)</span>
            <strong>
              Bs. {data.resumen.totalCobrado + data.resumen.totalAbonado}
            </strong>
          </div>

          <div style={box}>
            <span>Caja del día (con gastos)</span>
            <strong>
              Bs.{" "}
              {data.resumen.totalCobrado +
                data.resumen.totalAbonado -
                data.resumen.totalGastos}
            </strong>
          </div>

          {/* MAPA */}
 {/* 7️⃣ MAPA - OPENSTREETMAP CON ZOOM Y MOUSE */}
<div
  style={{
    width: "100%",
    height: 400,
    border: "2px solid #ccc",
    borderRadius: 8,
    overflow: "hidden",
    marginTop: 20,
  }}
>
  <MapContainer
    center={[-21.5354, -64.7296]} // TARIJA, BOLIVIA
    zoom={13}
    zoomControl={false}   // Desactivamos el default para ponerlo abajo derecha
    scrollWheelZoom={true} // ✔ Permite zoom con mouse
    style={{ width: "100%", height: "100%" }}
  >
    {/* Botones de zoom (abajo a la derecha) */}
    <ZoomControl position="bottomright" />

    {/* Capa del mapa */}
    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      attribution="&copy; OpenStreetMap contributors"
    />

    {/* Marcadores de VISITAS del día */}
    {data?.visitas?.map((v, i) =>
      v.lat && v.lng ? (
        <Marker key={i} position={[v.lat, v.lng]}>
          <Popup>
            <strong>{v.nombre}</strong>
            <br />
            Último pago: Bs. {v.monto || "?"}
          </Popup>
        </Marker>
      ) : null
    )}
  </MapContainer>
</div>


        </div>
      )}
    </div>
  );
}
